import { createElement } from 'react'

import {
  Info,
  TriangleAlert,
} from 'lucide-react'
import toast from 'react-hot-toast'

const politeAriaProps = {
  role: 'status',
  'aria-live': 'polite',
} as const

const assertiveAriaProps = {
  role: 'alert',
  'aria-live': 'assertive',
} as const

const infoStyle = {
  border: '1px solid var(--toast-info-border)',
  borderLeft:
    '3px solid var(--toast-info-foreground)',

  background: 'var(--toast-info-background)',

  color: 'var(--toast-info-foreground)',
} as const

const warningStyle = {
  border: '1px solid var(--toast-warning-border)',
  borderLeft:
    '3px solid var(--toast-warning-foreground)',

  background: 'var(--toast-warning-background)',

  color: 'var(--toast-warning-foreground)',
} as const

const infoIcon = createElement(
  Info,
  {
    size: 19,
    strokeWidth: 2.25,
  },
)

const warningIcon = createElement(
  TriangleAlert,
  {
    size: 19,
    strokeWidth: 2.25,
  },
)

export const notification = {
  success(message: string): string {
    return toast.success(message, {
      ariaProps: politeAriaProps,
    })
  },

  info(message: string): string {
    return toast(message, {
      ariaProps: politeAriaProps,

      icon: infoIcon,

      style: infoStyle,
    })
  },

  warning(message: string): string {
    return toast(message, {
      ariaProps: politeAriaProps,

      icon: warningIcon,

      style: warningStyle,
    })
  },

  error(message: string): string {
    return toast.error(message, {
      ariaProps: assertiveAriaProps,
    })
  },

  loading(message: string): string {
    return toast.loading(message, {
      duration: Infinity,
      ariaProps: politeAriaProps,
    })
  },

  updateSuccess(
    toastId: string,
    message: string,
  ): void {
    toast.success(message, {
      id: toastId,
      ariaProps: politeAriaProps,
    })
  },

  updateError(
    toastId: string,
    message: string,
  ): void {
    toast.error(message, {
      id: toastId,
      ariaProps: assertiveAriaProps,
    })
  },

  dismiss(toastId?: string): void {
    toast.dismiss(toastId)
  },
}
